import React from 'react';
import ECharts from 'echarts-for-react';

const LineChart = ({ data, config, title }) => {
  const xAxisKey = config?.xAxis || (data?.length > 0 ? Object.keys(data[0])[0] : null);
  const yAxisKey = config?.yAxis || (data?.length > 0 ? Object.keys(data[0])[1] : null);

  if (!xAxisKey || !yAxisKey || !data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const option = {
    title: {
      text: title || 'Line Chart',
      textStyle: { color: '#201e1d' },
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#201e1d',
      borderColor: 'transparent',
      borderWidth: 0,
      borderRadius: 8,
      textStyle: { color: '#f5ead8' },
    },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    xAxis: {
      type: 'category',
      data: data.map((item) => item[xAxisKey]),
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
      splitLine: { lineStyle: { color: '#eee7db' } },
    },
    series: [
      {
        data: data.map((item) => Number(item[yAxisKey]) || 0),
        type: 'line',
        smooth: true,
        itemStyle: { color: '#c67139' },
        lineStyle: { color: '#c67139', width: 2 },
        areaStyle: {
          color: new (require('echarts').graphic.LinearGradient)(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(198, 113, 57, 0.3)' },
            { offset: 1, color: 'rgba(198, 113, 57, 0)' },
          ]),
        },
      },
    ],
  };

  return (
    <ECharts
      option={option}
      style={{ width: '100%', height: '400px' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default LineChart;
